import { Component, Vue } from 'vue-property-decorator'
import qs from 'qs'

@Component
export class QueryMixin extends Vue {
  get queryString() {
    const [, queryString = ''] = this.$route.fullPath.match(/\/.*?\?(.*?)$/) || []
    return queryString
  }

  get parsedQuery() {
    return qs.parse(this.queryString)
  }
}
